import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import { ListView } from "../list-view/listView";

export class ExpansionPanelView extends Component {
  constructor(props) {
    super(props);
    const { listData } = this.props;
    this.state = {
      selectedItem: listData.filter((item) => item.checked),
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedItem: nextProps.listData.filter((item) => item.checked),
    });
  }

  render() {
    const { listData, handleChange } = this.props;
    const { selectedItem } = this.state;
    return (
      <ExpansionPanel>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{`${selectedItem.length} Vehicle${selectedItem.length > 1 ? "s" : ""} Selected`}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <ListView data={listData} handleChange={handleChange} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}
